<template>
    <div class="resume">
        <div class="resume_education">
            <h3>{{$t('education_bg')}}
                <small>（{{$t('tip')}}）</small>
            </h3>
            <input name='field' style='border:none; font-size:0;width: 0;height: 0;' value='education'>
            <input name="resume_id" style='border:none; font-size:0;width: 0;height: 0;' value='' v-model="resume_id">

            <!--  <resumeEducation v-for="(educationContent,i) in this.educationLists"
                               :eductionItem="educationContent"  :educationItemId="i" :key="i"
                               @removeEducationList="removeEducation"></resumeEducation>-->
            <resumeEducation v-if="this.educationLists.length>0"></resumeEducation>
        </div>
        <div class="resume_job">
            <h3>{{$t('experience')}}
                <small>（{{$t('tip')}}）</small>
            </h3>
            <input name='field' style='border:none; font-size:0;width: 0;height: 0;' value='experience'>
            <input name="resume_id" style='border:none; font-size:0;width: 0;height: 0;' value=' ' v-model="resume_id">

            <resume-job v-if="this.jobLists.length>0"></resume-job>
        </div>
        <div class="resume_certificate">
            <h3>{{$t('certificate')}}
                <small>（{{$t('tip')}}）</small>
            </h3>
            <input name='field' style='border:none; font-size:0;width: 0;height: 0;' value='sundry'>
            <input name="resume_id" style='border:none; font-size:0;width: 0;height:0' v-model="resume_id">
            <resume-certificate v-if="this.sundryLists.length>0"></resume-certificate>
            <!--  <p class="continue">
                  <span @click="addResumeCertificate()">+继续添加</span>
                  <span class="save">保存</span>
              </p>-->
        </div>
        <div class="resume_address">
            <h3>{{$t('address')}}
                <small>（{{$t('tip')}}）</small>
            </h3>
            <input name='field' style='border:none; font-size:0;width: 0;height: 0;' value='address'>
            <input name="resume_id" style='border:none; font-size:0;width: 0;height: 0;' value='' v-model="resume_id">
            <label>{{$t('detail_address')}}</label><input type="text" v-model="address" name="address" placeholder="请填写有效详细地址">
            <p class="continue">
                <span class="save" @click="saveAddress()">{{$t('save')}}</span>
            </p>
        </div>
        <span class="resume_btn" @click="submitResume()">{{$t('submit_applications')}}</span>

    </div>
</template>

<script>
import resumeJob from "../../components/endPage/resumeJob";
import resumeCertificate from "../../components/endPage/resumeCertificate";
import resumeEducation from "../../components/endPage/resumeEducation";
export default {
  name: "resume",
  inject: ["showMsg"],
  components: {
    resumeJob,
    resumeCertificate,
    resumeEducation
  },
  data: function() {
    return {
      isShowConfirm: false,
      resume_id: "",
      educationLists: [
        {
          start_time: "",
          end_time: "",
          education: "",
          school_name: "",
          education_id: ""
        }
      ],
      jobLists: [
        {
          company_name: "",
          position_name: "",
          work_time_start: "",
          work_time_end: "",
          intro: "",
          experience_id: ""
        }
      ],
      sundryLists: [
        {
          name: "",
          awardtime: "",
          organization: "",
          sundry_id: ""
        }
      ],
      address: "",
      educationObj: {},
      jobObj: {},
      sundryObj: {}
    };
  },
  created: function() {
    this.GetRecord();
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "resume");
  },
  methods: {
    GetRecord() {
      //获取个人资料
      this.$http({
        url: this.weburl + "/home/job/getRecord",
        type: "post",
        dataType: "json"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status === 1) {
            if (
              res.data.result.education.length === 0 &&
              res.data.result.experience.length === 0 &&
              res.data.result.sundry.length === 0
            ) {
              // console.log('首次填写')
              this.FirstGetRecord(res.data.result);
            } else {
              // console.log('有填写记录');
              // this.$store.commit("set_end_information", res.data.result);
              this.GetRecordInfo(res.data.result);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    FirstGetRecord(data) {
      this.resume_id = data.resume_id;
      this.educationList = this.educationLists;
      this.sundryList = this.sundryLists;
      this.jobList = this.jobLists;
    },
    GetRecordInfo(data) {
      this.resume_id = data.resume_id;
      this.$store.commit("set_end_information", data.resume_id);
      if (data.education.length > 0) {
        this.educationLists = [];
        for (let e = 0; e < data.education.length; e++) {
          this.educationObj.start_time = data.education[e].start_time;
          this.educationObj.end_time = data.education[e].end_time;
          this.educationObj.school_name = data.education[e].school_name;
          this.educationObj.education_id = data.education[e].education_id;
          this.educationObj.education = data.education[e].education;
          this.educationLists.push(this.educationObj);
          this.educationObj = {};
        }
      }
      this.$store.commit("set_educationList", this.educationLists);
      if (data.experience.length > 0) {
        this.jobLists = [];
        for (let e = 0; e < data.experience.length; e++) {
          this.jobObj.company_name = data.experience[e].company_name;
          this.jobObj.position_name = data.experience[e].position_name;
          this.jobObj.work_time_start = data.experience[e].work_time_start;
          this.jobObj.work_time_end = data.experience[e].work_time_end;
          this.jobObj.intro = data.experience[e].intro;
          this.jobObj.experience_id = data.experience[e].experience_id;
          this.jobLists.push(this.jobObj);
          this.jobObj = {};
        }
      }
      this.$store.commit("set_jobList", this.jobLists);
      if (data.sundry.length > 0) {
        this.sundryLists = [];
        for (let e = 0; e < data.sundry.length; e++) {
          this.sundryObj.name = data.sundry[e].name;
          this.sundryObj.awardtime = data.sundry[e].awardtime;
          this.sundryObj.organization = data.sundry[e].organization;
          this.sundryObj.sundry_id = data.sundry[e].sundry_id;
          this.sundryLists.push(this.sundryObj);
          this.sundryObj = {};
        }
      }
      this.$store.commit("set_sundryList", this.sundryLists);
      this.address = data.address;
    },
    saveAddress() {
      if (this.address === "") {
        this.showMsg("请填写地址");
        return false;
      }
      this.$http({
        url: this.weburl + "/home/job/userinfoHandle",
        method: "POST",
        dataType: "json",
        data: {
          resume_id: this.end_information,
          address: this.address
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.showMsg("保存成功");
          }
        })
        .catch(() => {
          this.showMsg();
        });
    },
    submitResume() {
      this.$http({
        method: "post",
        url: this.weburl + "/home/job/jobHandle",
        dataType: "json",
        data: {
          job_id: this.$route.params.id,
          resume_id: this.end_information
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            //提交成功
            this.showSuccessBox();
          } else {
            this.showMsg("提交失败");
            // this.$router.push({name: `basicInformation`,params:{id:this.$route.params.id}});
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    showSuccessBox() {
      //提交成功
      this.$msgbox({
        content:
          "<div  style='height: 50px;width: 40px;margin:0 auto 10px; background: url(../../../static/img/confirm.png) no-repeat ; background-size: 40px auto; '></div><p style='width: 60%;margin: 0 auto; text-align: center; line-height: 20px;font-size: 1rem;'>简历已经上传成功<br>请继续投递简历吧！</p>",
        confirm: "继续投递",
        className: "pop-custom"
      })
        .then(() => {
          this.$router.push({ path: `/joinUs` });
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    end_information: function() {
      return this.$store.state.endPage.end_information;
    },
    weburl: function() {
      return this.$store.state.weburl;
    },
    educationList() {
      return this.$store.state.endPage.educationList;
    },
    jobList() {
      return this.$store.state.endPage.jobList;
    },
    sundryList() {
      return this.$store.state.endPage.sundryList;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/resume.less";

.resume {
  position: relative;
  & > div {
    .padding;
    .border-bottom(5px; @bg);
    font-size: @font - 0.1;
    &.resume_address {
      border-bottom: none;
    }
    h3 {
      font-size: @font;
      small {
        font-size: 0.4rem;
      }
    }
  }
  .resume_btn {
    .btn;
    display: block;
    .width;
  }
  .resume_confirm {
    position: absolute;
    width: @width;
    top: -44px;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    z-index: 99999;
    border-bottom: none;
    .confirm {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
      width: 80%;
      height: 200px;
      background: @font-primary;
      .border-radius(10px);
    }
  }
}
</style>
